import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/oms-operation-service/v1";
//分页申请列表
export const getMultichargeList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/multicharge/page", data, config);
};
//审核一卡多充
export const auditMultiCharge = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/multicharge/audit_multiCharge", data, config);
};
//分页查询公告内容
export const getNoticeList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/notice/info/page/notice", data, config);
};
//删除公告内容
export const delNotice = (data = {}, config: objAny = {}) => {
  config.method = "getDel";
  return request(API_URL + "/notice/info/delete/station/notice", data, config);
};
//添加系统公告内容
export const addNotice = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/notice/info/add/system/notice", data, config);
};
//通过桩id获取充电枪信息
export const getStatGunKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/get/gun_by_pile", data, config);
};
//通过设备id获取桩id信息
export const getPileByDevice = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/get/pile_by_device", data, config);
};
export const getMonitorGunInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/gun/info", data, config);
};
//通过桩id获取费率详情信息
export const getFeeByPile = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/get_fee_by_pile", data, config);
};
//获取单个桩的枪口实时数据
export const getPileData = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/pile/data", data, config);
};
//询费率下拉列表,费率feePkId - 费率名称
export const getFeeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/list", data, config);
};
// 获取充电站
export const getStaKvs = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/sta_kvs", data, config);
};
// 分页查询消费者日志
export const getCosumerLogList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/cosumer/log/page", data, config);
};
// 删除日志
export const delCosumerLog = (data = {}, config: objAny = {}) => {
  config.method = "del";
  return request(API_URL + "/cosumer/log/del", data, config);
};
// 重新消费
export const reconsumeCosumerLog = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/cosumer/log/reconsume", data, config);
};
// 批量重新消费
export const batchReconsumeCosumerLog = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/cosumer/log/batch_reconsume", data, config);
};
// 系统查询待办事项详情
export const getBacklogSysDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/backlog/sys/detail", data, config);
};
// 新增增值服务
export const addAccretionService = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/accretion/service/add", data, config);
};
// 删除增值服务
export const delAccretionService = (data = {}, config: objAny = {}) => {
  config.method = "postStr";
  return request(API_URL + "/opr/accretion/service/del", data, config);
};
// 查询所有增值服务
export const getAccretionService = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/accretion/service/list", data, config);
};
// 修改增值服务
export const upAccretionService = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/accretion/service/upd", data, config);
};

// 站点规模 - 查看站点规模统计信息
export const getStaSizeStatistics = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/size/statistics", data, config);
};
// 站点规模 - 查看站点规模配置信息
export const getStaSizeConfig = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/size/get", data, config);
};
// 站点规模 - 查看站点规模配置信息
export const updataStaSizeConfig = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/sta/size/update", data, config);
};
